import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16 33.855V14.668c0-2.748 3.07-4.38 5.348-2.841l14.39 9.721c2.028 1.37 2.01 4.361-.035 5.706l-14.39 9.465c-2.28 1.5-5.313-.135-5.313-2.864" }, null, -1)
  ])))
}
export default { render: render }